import React, { PropTypes } from 'react'
import classNames from 'classnames'
import ArrowImg from 'images/arrow.png'

const Accessory = ({ selected, accessoryType, reshaft, restoration, isError, onSelectAccessoryType, onRemoveAccessory }) => (
  <div className={classNames({ "error" : isError })}>
    {onSelectAccessoryType ?
      <div>
        {selected &&
          <div className="accessory-selector">
            <img onClick={onSelectAccessoryType} style={{cursor: "pointer"}} src={selected.imageUrl} alt={selected.label} />
            <div className="accessory-selector-text">
              <div className="accessory-label">{selected.label}</div>
              <div className="accessory-price">${selected.price}</div>
                <div className="accessory-link" onClick={() => onRemoveAccessory(accessoryType, 0)} style={{cursor: "pointer"}}>REMOVE</div>
                <div className="accessory-link" onClick={onSelectAccessoryType} style={{cursor: "pointer"}}>EDIT</div>
              </div>
            <img className="accessory-arrow-img" src={ArrowImg} alt={`Edit`} onClick={onSelectAccessoryType} style={{cursor: "pointer"}}/>
          </div>
        }
        {!selected &&
          <div className="accessory-selector">
            <div onClick={onSelectAccessoryType} style={{cursor: "pointer"}} className="no-selection"></div>
            <div className="accessory-selector-text">
              <div>NONE</div>
              <div className="accessory-link" onClick={onSelectAccessoryType} style={{cursor: "pointer"}}>CHOOSE {accessoryType.replace('shaftBand', 'shaft band')}</div>
            </div>
            <img className="accessory-arrow-img" src={ArrowImg} alt={`Edit`} onClick={onSelectAccessoryType} style={{cursor: "pointer"}}/>
          </div>
        }
      </div>
      :
      <div>
        {selected &&
          <div className="accessory-selector">
            <img src={selected.imageUrl} alt={selected.label} />
            <div className="accessory-selector-text">
              <div className="accessory-label">{selected.label}</div>
              <div className="accessory-price">${selected.price}</div>
            </div>
          </div>
        }
        {!selected &&
          <div className="accessory-selector">
            <div className="no-selection"></div>
            <div className="accessory-selector-text">NONE</div>
          </div>
        }
      </div>
    }
  </div>
)

const AccessorySelection = ({ selected, accessoryType, onSelectAccessoryType,  isError, className, onRemoveAccessory }) => (
  <div className={className}>
    <div className="customize-form-section-header">{accessoryType.replace('shaftBand', 'shaft band')}</div>
    {onSelectAccessoryType
    ? 
      <div>
        {className === 'mobile'
        ?
          <div>
            <Accessory onRemoveAccessory={onRemoveAccessory} onSelectAccessoryType={() => onSelectAccessoryType(accessoryType)} selected={selected} accessoryType={accessoryType} isError={isError}/> 
          </div>
        :
          <div onClick={() => onSelectAccessoryType(accessoryType)} style={{cursor: "pointer"}} >
            <Accessory selected={selected} accessoryType={accessoryType} isError={isError}/>
          </div>
        }
      </div>
    :
      <div>
        <Accessory selected={selected} accessoryType={accessoryType} isError={isError}/>
      </div>
    }
  </div>
)
  

AccessorySelection.defaultProps = {
}

AccessorySelection.propTypes = {
  accessoryType: PropTypes.string.isRequired,
  selected: PropTypes.object,
  onSelectAccessoryType: PropTypes.func,
  isError: PropTypes.bool,
  className: PropTypes.string,
  onRemoveAccessory: PropTypes.func,
}

export default AccessorySelection